export default class HomePageViewModel {
	componentDidMount(): void {}
}
